module.exports = __webpack_public_path__ + "img/autosense-account-flows.998db94d.png";